import { styled, Box } from "@mui/material";
import { lighten } from "@mui/system";

export const Content = styled(Box)(({ theme }) => ({
    opacity: 0.9,
    marginBottom: "0.3em",
    transition: "opacity 0.5s",
    "& p": {
        margin: 0,
    },
    "& a": {
        color: theme.palette.primary.main,
        textDecoration: "none",
    },
    "& blockquote": {
        margin: 0,
        paddingLeft: 10,
        borderLeft: `4px solid ${lighten(theme.palette.background.default, 0.4)}`,
    },
}));

export const ContentLoading = styled(Content)({
    opacity: 0.3,
});

export const FileContent = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    display: "flex",
    borderRadius: theme.shape.borderRadius,
    alignItems: "center",
    backgroundColor: lighten(theme.palette.background.default, 0.2),
}));

export const Filename = styled(Box)({
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: 0,
    fontSize: "0.9em",
    marginRight: 5,
    flexGrow: 1,
});

export const Icon = styled(Box)({
    margin: 10,
});

export const ImagePreview = styled("img")(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    cursor: "pointer",
    maxWidth: "100%",
}));

export const ImageContainer = styled(Box)({
    position: "relative",
    overflow: "hidden",
});

export const ImageDetails = styled(Box)({
    position: "absolute",
    width: "100%",
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(4px)",
    padding: "3px 6px",
});

export const containerSpacing = "0.8em";
